import React, { useState } from "react";
import "./TechCarousel.css";
import CarouselData from "./TechCarousel.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export default function TechCarousel() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: false,
    nextArrow: <></>,
    prevArrow: <></>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="w-100">
        <div data-aos="zoom-in-up" className="container-fluid px-0">
          <Slider {...settings}>
            {CarouselData.map((item, id) => (
              <div key={id} className="p-3">
                <img className={item.class} src={item.img} alt={item.title} />
                <h5 className="small_heading text-white">{item.title}</h5>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
}
